var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C16.4184 4 20 7.58188 20 12C20 16.4181 16.4184 20 12 20C7.58165 20 4 16.4181 4 12C4 7.58188 7.58165 4 12 4ZM12 5.33333C8.31811 5.33333 5.33333 8.31817 5.33333 12C5.33333 15.6818 8.31811 18.6667 12 18.6667C15.6819 18.6667 18.6667 15.6818 18.6667 12C18.6667 8.31817 15.6819 5.33333 12 5.33333ZM13.3333 12.6866C13.3343 12.8646 13.2639 13.0358 13.1377 13.1623L10.4469 15.8389C10.1639 16.0795 9.73806 16.0468 9.49556 15.7658C9.27926 15.5152 9.27926 15.1451 9.49556 14.8943L11.9839 12.4119V7.33666C11.9839 6.96659 12.2859 6.66667 12.6586 6.66667C13.0313 6.66667 13.3333 6.96659 13.3333 7.33666V12.6866Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressHistory);
export default __webpack_public_path__ + "static/media/ProgressHistory.f02bb50b348ae271960fa55185a3bb71.svg";
export { ForwardRef as ReactComponent };